'use client'

import { clsx } from 'clsx'

interface FilterPillsProps {
  options: string[]
  selected: string
  onChange: (value: string) => void
}

export function FilterPills({ options, selected, onChange }: FilterPillsProps) {
  return (
    <div className="flex gap-1.5 overflow-x-auto pb-1 flex-shrink-0">
      {options.map((option) => (
        <button
          key={option}
          onClick={() => onChange(option)}
          className={clsx(
            'px-3 py-1.5 rounded-full text-[12px] font-medium whitespace-nowrap flex-shrink-0 transition-colors',
            selected === option
              ? 'bg-brand-primary text-black'
              : 'bg-bg-subtle text-text-secondary hover:text-text-primary'
          )}
        >
          {option}
        </button>
      ))}
    </div>
  )
}
